module.exports = __webpack_public_path__ + "22a47c251ef05635e47ec60bbe352c3d.png";